export default {"src":"/_next/static/media/heroBgSpanish.5402b4df.svg","height":73,"width":284,"blurWidth":0,"blurHeight":0};